import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/cashdrawer';

const openLogs = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/records`, payload);
};

const declarations = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/cashdeclarations`, payload);
};

const floats = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/cashFloatTable`, payload);
};

export default {
	openLogs,
	declarations,
	floats,
};
